import tessaLogo from "src/assets/tessa-logo.svg";

// Full-viewport blank page with the Tessa logo centred. Used while the auth
// context resolves the session cookie via /api/auth/me — without it the
// browser shows a flash of empty white before either the home screen
// renders or the WorkOS redirect kicks in.
export function LoadingScreen() {
  return (
    <div className="w-screen h-screen flex items-center justify-center bg-neutral-2">
      <img src={tessaLogo} alt="Tessa" className="h-12" />
    </div>
  );
}
